import React, {memo} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import PropTypes from "prop-types";

const DeleteModal = (props) => {
  const {
    header = "",
    modalBody = "",
    onClose = () => {},
    onDelete = () => {},
    open,
  } = props;

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"md"}>
      <ModalHeader>{header}</ModalHeader>
      <ModalBody>{modalBody}</ModalBody>
      <ModalFooter>
        <Button color={"danger"} data-cy={"delete-btn"} onClick={onDelete}>
          DELETE
        </Button>
        <Button onClick={onClose} data-cy={"cancel-btn"}>
          CANCEL
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteModal.propTypes = {
  /** Title of modal */
  header: PropTypes.string.isRequired,
  /** Content of modal */
  modalBody: PropTypes.string.isRequired,
  /** Callback function which will be executed on cancel */
  onClose: PropTypes.func.isRequired,
  /** Callback function which will be executed on delete */
  onDelete: PropTypes.func.isRequired,
  /** State to set whether modal is open */
  open: PropTypes.bool.isRequired,
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

export default memo(DeleteModal, areEqual);
